import { render, staticRenderFns } from "./FormMixin.vue?vue&type=template&id=2d1a768b&scoped=true&"
import script from "./FormMixin.vue?vue&type=script&lang=js&"
export * from "./FormMixin.vue?vue&type=script&lang=js&"
import style0 from "./FormMixin.vue?vue&type=style&index=0&id=2d1a768b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1a768b",
  null
  
)

export default component.exports